import { render, staticRenderFns } from "./WhatsAppNonOficial.vue?vue&type=template&id=3dbef555&"
import script from "./WhatsAppNonOficial.vue?vue&type=script&lang=js&"
export * from "./WhatsAppNonOficial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports